// Mapeamento das 48 seleções da Copa 2026 para confederações continentais.
// (`./confederations.ts` é sobre grupos A..L do torneio, conceito diferente.)
// Usado para calcular medalhas e eventos `confed_complete`.

export type Confederation = 'CONMEBOL' | 'UEFA' | 'CONCACAF' | 'CAF' | 'AFC' | 'OFC';

export const CONFEDERATION_BY_TEAM: Record<string, Confederation> = {
  // CONMEBOL (6)
  BRA: 'CONMEBOL', ARG: 'CONMEBOL', URU: 'CONMEBOL', PAR: 'CONMEBOL', COL: 'CONMEBOL', ECU: 'CONMEBOL',
  // UEFA (16)
  CZE: 'UEFA', BIH: 'UEFA', SUI: 'UEFA', SCO: 'UEFA', TUR: 'UEFA', GER: 'UEFA',
  NED: 'UEFA', SWE: 'UEFA', BEL: 'UEFA', ESP: 'UEFA', FRA: 'UEFA', NOR: 'UEFA',
  AUT: 'UEFA', POR: 'UEFA', ENG: 'UEFA', CRO: 'UEFA',
  // CONCACAF (6)
  MEX: 'CONCACAF', CAN: 'CONCACAF', HAI: 'CONCACAF', USA: 'CONCACAF', CUW: 'CONCACAF', PAN: 'CONCACAF',
  // CAF (10)
  RSA: 'CAF', MAR: 'CAF', CIV: 'CAF', TUN: 'CAF', EGY: 'CAF', CPV: 'CAF',
  SEN: 'CAF', ALG: 'CAF', COD: 'CAF', GHA: 'CAF',
  // AFC (9)
  KOR: 'AFC', QAT: 'AFC', AUS: 'AFC', JPN: 'AFC', IRN: 'AFC', KSA: 'AFC',
  IRQ: 'AFC', JOR: 'AFC', UZB: 'AFC',
  // OFC (1)
  NZL: 'OFC',
};

const _byConfed: Record<Confederation, string[]> = {
  CONMEBOL: [],
  UEFA: [],
  CONCACAF: [],
  CAF: [],
  AFC: [],
  OFC: [],
};

for (const [team, confed] of Object.entries(CONFEDERATION_BY_TEAM)) {
  _byConfed[confed].push(team);
}

export const TEAMS_BY_CONFEDERATION: Record<Confederation, readonly string[]> = _byConfed;

export const ACHIEVEMENT_ID_BY_CONFEDERATION: Record<Confederation, string> = {
  CONMEBOL: 'conmebol',
  UEFA: 'uefa',
  CONCACAF: 'concacaf',
  CAF: 'caf',
  AFC: 'afc',
  OFC: 'ofc',
};
